import React, { useEffect, useState } from 'react';
import { useContracts } from '../../hooks/useContract';
import { useNotify } from '../../context/NotificationContext';
import { ButtonSpinner } from '../common/Loader';
import { parseError } from '../../utils/errors';
import { formatUsdc, bnToNumber } from '../../utils/format';
import { RANK_NAMES, NUM_RANKS } from '../../utils/constants';

export const RankPoolDistribute = () => {
  const { viewsR, adminW } = useContracts();
  const notify = useNotify();

  const [pools, setPools] = useState(null);
  const [busy, setBusy] = useState(null);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!viewsR) return;
      try {
        const proms = [];
        for (let i = 0; i < NUM_RANKS; i++) proms.push(viewsR.getRankPoolState(i));
        const arr = await Promise.all(proms);
        if (cancelled) return;
        setPools(arr);
      } catch (e) {}
    };
    load();
    return () => { cancelled = true; };
  }, [viewsR, reload]);

  const distribute = async (rankIdx) => {
    if (!adminW) return;
    setBusy(rankIdx);
    try {
      const tx = await adminW.distributeRankPool(rankIdx);
      notify.info('Distributing rank pool...');
      await tx.wait();
      notify.success(`${RANK_NAMES[rankIdx + 1]} pool distributed`);
      setReload((r) => r + 1);
    } catch (e) {
      notify.error(parseError(e));
    } finally {
      setBusy(null);
    }
  };

  return (
    <div>
      <div className="card">
        <div className="section-title">Weekly Rank Pool Distribution</div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 14, marginBottom: 20 }}>
          Distribute accumulated pool funds equally across eligible users of each rank. Run weekly per your protocol schedule.
        </p>

        <div className="grid grid-auto">
          {pools && pools.map((p, i) => {
            const acc = p.accumulator;
            const elig = bnToNumber(p.eligibleCount);
            const round = bnToNumber(p.currentRound);
            const perUser = elig > 0 ? acc.div(elig) : acc;
            const isBusy = busy === i;
            const canDistribute = !acc.isZero() && elig > 0;

            return (
              <div key={i} className="card" style={{ padding: 20 }}>
                <div style={{ fontWeight: 700, fontSize: 15, marginBottom: 12 }}>{RANK_NAMES[i + 1]}</div>
                <div className="kv-list mb-24">
                  <div className="kv-row"><span className="kv-key">Accumulated</span><span className="kv-val">${formatUsdc(acc)}</span></div>
                  <div className="kv-row"><span className="kv-key">Eligible</span><span className="kv-val">{elig}</span></div>
                  <div className="kv-row"><span className="kv-key">Per User</span><span className="kv-val">${formatUsdc(perUser)}</span></div>
                  <div className="kv-row"><span className="kv-key">Round</span><span className="kv-val">#{round}</span></div>
                </div>
                <button
                  className="btn btn-primary btn-full"
                  onClick={() => distribute(i)}
                  disabled={isBusy || !canDistribute}
                >
                  {isBusy && <ButtonSpinner />}
                  {canDistribute ? 'Distribute' : 'Nothing to distribute'}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
